import { Navigate, Outlet } from 'react-router-dom'
import { getAuthToken } from '../utils/auth'

export default function ProtectedRoute() {
  if (!getAuthToken()) {
    return <Navigate to="/login" replace />
  }
  return <Outlet />
}
